import { useContext, useEffect, useState } from 'react';

import { NotificationContext } from '../../../contexts/NotificationsContext';
import extractTextFromReactNode from '../../../utils/extractTextFromReactNode';
import AtomTypography from '../../atoms/AtomTypography/AtomTypography';

const ScreenReaderLiveRegion: React.FC = () => {
  const { contentData } = useContext(NotificationContext);
  const { listNotifications } = contentData;
  const [announceText, setAnnounceText] = useState<string>('');

  useEffect(() => {
    if (!listNotifications || listNotifications.length === 0) {
      return undefined;
    }

    const latestNotification = listNotifications[listNotifications.length - 1];
    let descriptionText = '';

    if (typeof latestNotification.description === 'string') {
      descriptionText = latestNotification.description;
    } else if (latestNotification.description) {
      descriptionText = extractTextFromReactNode(latestNotification.description);
    }

    const textToAnnounce = `${latestNotification.title}. ${descriptionText}`;

    setAnnounceText('');
    const timeoutId = setTimeout(() => {
      setAnnounceText(textToAnnounce);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [listNotifications]);

  return (
    <AtomTypography
      aria-live="assertive"
      aria-atomic="true"
      sx={{
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden',
      }}
    >
      {announceText}
    </AtomTypography>
  );
};

export default ScreenReaderLiveRegion;
